module.exports = __webpack_public_path__ + "static/sc-01.6218d74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/projects/avexp/sc-01.png
// module id = 82
// module chunks = 88197199937824 213720915766396 248457553330650